<template>
    <div>
        <div class="breadcrumb">
            <Breadcrumb>
                <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
                <Breadcrumb-item>学员生命周期</Breadcrumb-item>
            </Breadcrumb>
        </div>
        <div>
            <Form label-position="left" :label-width="80">
                <Row :gutter="32" index="1">
                    <Col span="6">
                        <FormItem label="选择日期:" v-if="queryParam.dayOfMonth == 0">
                            <DatePicker @on-change="getTimeDateChange"
                                        placement="bottom-start" 
                                        format="yyyy-MM-dd" 
                                        :type="type" 
                                        :value="defaultDate"
                                        placeholder="选择起始时间"
                                        style="width: 100%">
                            </DatePicker>
                        </FormItem>
                        <FormItem label="选择月:" v-if="queryParam.dayOfMonth == 1">
                            <DatePicker @on-change="getTimeMonthChange"
                                        :type="type"
                                        placeholder="选择月"
                                        style="width: 100%">
                            </DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="查看方式:">
                            <Radio-group v-model="queryParam.dayOfMonth" @on-change="search">
                                <Radio label="0">按日查看</Radio>
                                <Radio label="1">按月查看</Radio>
                            </Radio-group>
                        </FormItem>
                    </Col>
                    <Col :span="2">
                      <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                        @click="search">搜索
                      </Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="btn-wrap">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading"
            @click="exportData">导出
          </Button>
        </div>
        <List ref="dataList" :tableColumns="table" listUrl="/data/report/querystudyadviserdata"
            :params="queryParam" :reload="reload"></List>

        <Modal v-model="tableRulePrompt" title="规则">
            {{tableRulePromptContent}}
            <div slot="footer">
                <Button type="text" size="large" @click="cancel">取消</Button>
                <Button type="primary" size="large" @click="cancel">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            searchLoading: false,
            reload: 0,
            defaultDate: [],
            queryParam: {
                startTime: '',
                endTime: '',
                dayOfMonth: 0
            },
            tableRulePrompt: false,
            tableRulePromptContent: '',
            type: '',
            table: [
                {
                    title: '时间',
                    align: 'center',
                    key: 'day',
                    render: (h,params)=>{
                        let row = params.row
                        if(this.queryParam.dayOfMonth == 0) return h('div', row.gmtCreate)
                        return h('div', row.day)
                    }
                },
                {
                    align: 'center',
                    key: 'endCourseNum',
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生状态变更记录】：最近一条变更记录状态为“结课学生” 且时间为对应日期的学生数量'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '结课学生流失量');
                    }
                },
                {
                    align: 'center',
                    key: 'returnPremiumNum',
                    renderHeader: (h,params)=>{
                        let tableHeader = '【学生状态变更记录】：最近一条变更记录状态为“退费学生” 且时间为对应日期的学生数量'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '退费学生流失量');
                    }
                },
                {
                    align: 'center',
                    key: 'endCourseLifeCycle',
                    renderHeader: (h,params)=>{
                        let tableHeader = '∑（结课学生状态变更记录创建时间 - 学生注册时间）/ 结课学生流失量'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '平均结课生命周期');
                    }
                },
                {
                    align: 'center',
                    key: 'returnLifeCycle',
                    renderHeader: (h,params)=>{
                        let tableHeader = '∑（退费学生状态变更记录创建时间 - 学生注册时间）/ 结课学生流失量'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '平均退费生命周期');
                    }
                },
                {
                    align: 'center',
                    key: 'totalLifeCycle',
                    renderHeader: (h,params)=>{
                        let tableHeader = '∑（结课学生状态 +退费学生状态 变更记录创建时间 - 学生注册时间）/ 结课学生流失量'
                        return h('div', {
                            style: { color: '#3399ff' },
                            on: { click: ()=>this.showPrompt(tableHeader) }
                        }, '平均生命周期');
                    }
                }
            ]
        }
    },
    mounted: function () {
    },
    created: function () {
        let date = new Date()
        let today = this.$moment(new Date()).format('YYYY-MM-DD')
        let sevenDayAgo = this.$moment(new Date(date.getTime() - 168*60*60*1000)).format('YYYY-MM-DD')
        this.defaultDate = [sevenDayAgo, today]
        this.queryParam.startTime = sevenDayAgo
        this.queryParam.endTime = today
        console.log(`this.queryParam.dayOfMonth`, this.queryParam.dayOfMonth)
        this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month'
    },
    updated () {
        this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month'
    },
    methods: {
        search () {
            this.queryParam.dayOfMonth == 0 ? this.type = 'daterange' : this.type = 'month'
            this.reload = new Date().getTime()
        },
        
        showPrompt (value) {
            let self = this
            self.tableRulePrompt = true
            self.tableRulePromptContent = value
        },
        cancel () {
            let self = this
            self.tableRulePrompt = false
        },
        getTimeDateChange (val) {
            console.log(`日`, val)
            this.queryParam.startTime = val[0]
            this.queryParam.endTime = val[1]
        },
        getTimeMonthChange (val) {
            console.log(`月`, val)
            this.queryParam.startTime = val
            this.queryParam.endTime = val
        },
        exportData () {
            this.exportLoading = true
            this.$http.get('/data/report/exporUserLifeCycleData', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
                let blob = new Blob([response.data], {type: 'text/csv'})
                let link = document.createElement('a')
                link.target = '_blank'
                link.href = window.URL.createObjectURL(blob)
                link.download = '学生生命周期.csv'
                link.click()
                this.exportLoading = false
            } else {
                this.$Message.error(response.msg)
            }
            }).catch((e) => {
            this.exportLoading = false
            })
        }
    }
}
</script>

<style scoped>
  .btn-wrap {
    text-align: right;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// StudentLifeCycle.vue?14916992